import React from 'react';

export const name = 'list';

export const List = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1.5"
      y1="3.9375"
      x2="3"
      y2="3.9375"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <line
      x1="4.5"
      y1="3.9375"
      x2="16.5"
      y2="3.9375"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <line
      x1="1.5"
      y1="8.4375"
      x2="3"
      y2="8.4375"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <line
      x1="4.5"
      y1="8.4375"
      x2="16.5"
      y2="8.4375"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <line
      x1="1.5"
      y1="12.9375"
      x2="3"
      y2="12.9375"
      stroke="currentColor"
      strokeWidth="1.125"
    />
    <line
      x1="4.5"
      y1="12.9375"
      x2="16.5"
      y2="12.9375"
      stroke="currentColor"
      strokeWidth="1.125"
    />
  </svg>
);
